import React from 'react';
import {
  Paper,
  Button,
  Divider,
  FormControl,
  Box,
  Alert,
  Snackbar
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { pt } from 'yup-locale-pt';
import {
  useNavigate,
  useLocation,
  useParams
} from "react-router-dom";
import {TextField} from '../../components';
import api from "../../services/api";
import { useStoreActions } from 'easy-peasy';
yup.setLocale(pt);

const EsqueciMinhaSenha = () => {
  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);
  let setUser = useStoreActions((actions) => actions.auth.setUser);

  let navigate = useNavigate();
  let location = useLocation();

  let from = location.state?.from?.pathname || "/";

  const schema = yup.object({
    email: yup.string().email().label('Email').required(),
  }).required();

  const useFormRef = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema)
  });


  const { handleSubmit,
          formState: {isDirty,isSubmitting} } = useFormRef;

  const onSubmit = async (data) => {
    startLoading();
    try {
      await api.http.post('/request-reset-password/',data);
      stopLoading({
        severity: 'success',
        message: ('Sua solicitação foi enviada com sucesso. '+
                  'Você receberá um email com instruções'),
        autoHideDuration: 4000
      });
      navigate('/login', { replace: true });
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    };
  };

  return (
    <Paper variant="outlined" className='center-box' sx={{
      textAlign: 'center',
      px: 4,
      pt: 2,
      pb: 3,
      m: 5,
      maxWidth: 'sm',
    }}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Divider>
          <h3>Esqueci minha senha</h3>
        </Divider>
        <FormControl sx={{ my: 2 }} fullWidth>
          <TextField field="email" type="email"
                     schema={schema} useFormRef={useFormRef} />
        </FormControl>
        <Box sx={{ mt: 2 }}>
          <Button type="submit" variant="contained" size="large"
                  endIcon={<ArrowForwardIcon />}
                  disabled={!isDirty || isSubmitting}>
            Enviar
          </Button>
        </Box>
      </form>
    </Paper>
  );
};

export default EsqueciMinhaSenha;
